angular
.module('typeAhead.components', [])
.component('typeAhead', {
	templateUrl: 'ng/components/typeAhead/typeAhead.html',
	bindings: {
		selectOptions : '<',
        model: '='
	},
	controllerAs: 'typeAheadCtrl',
	controller: function($scope, $translate, $filter) {
      
      //Not to loose the *this reference
      var self = this;

      //self.data = [];

      self.$onInit = function () { 
        //self.data = self.selectOptions;
        
        $('.select2#stato-pratica').select2({
          allowClear: true,
          placeholder: "Seleziona Stato Pratica"
        });    
      }
      
	}
});